var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBridgeIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_204_3481",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#8E97CD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_204_3481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2708 24.0181V26.8533C25.2708 26.8611 25.2787 26.869 25.2865 26.869H28.277H25.3179C25.3022 26.869 25.2944 26.8454 25.3022 26.8376C28.1835 24.3048 30.0049 20.6036 30.0049 16.4711C30.0049 8.85691 23.8263 2.67776 16.2111 2.66992C16.2032 2.66992 16.1875 2.67776 16.1875 2.69345V6.6311",
    stroke: "#F7F7FC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73404 7.98779L6.73404 5.15259C6.73404 5.14475 6.72619 5.13691 6.71834 5.13691L3.72786 5.13691L6.68694 5.13691C6.70264 5.13691 6.71049 5.16043 6.70264 5.16827C3.82141 7.70109 2.00003 11.4023 2.00003 15.5348C2.00003 23.149 8.17858 29.3281 15.7938 29.3359C15.8017 29.3359 15.8174 29.3281 15.8174 29.3124L15.8174 25.3748",
    stroke: "#F7F7FC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.1562,
    cy: 16.0097,
    r: 9.22062,
    stroke: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.44 16.2314L14.2083 19.0441C14.2143 19.0441 14.2143 19.0501 14.2203 19.0501L15.6177 20.0892C15.7371 20.1788 15.9043 20.0952 15.9043 19.9459L15.9103 12.2003C15.8984 12.0629 15.8805 11.9196 15.8506 11.7823C15.8207 11.6509 15.7789 11.5255 15.7192 11.418C15.8207 12.1764 15.3908 13.0603 14.6622 13.6395C14.5009 13.7709 14.28 13.9142 14.0351 14.0158C13.7724 14.1292 12.9781 14.4039 12.9781 14.4039L10.5833 15.2699C10.1713 15.4192 10.0877 15.9686 10.44 16.2314Z",
    fill: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1792 13.9465C14.1851 13.9405 14.1971 13.9405 14.203 13.9345C14.215 13.9286 14.2269 13.9226 14.2448 13.9106C14.2627 13.9047 14.2747 13.8927 14.2926 13.8868C14.2986 13.8808 14.3105 13.8748 14.3165 13.8748C14.3344 13.8629 14.3583 13.8509 14.3762 13.839C14.3822 13.833 14.3881 13.833 14.3941 13.8271C14.412 13.8151 14.4299 13.8032 14.4538 13.7912C14.4658 13.7853 14.4717 13.7793 14.4837 13.7733C14.4956 13.7614 14.5135 13.7554 14.5255 13.7435C14.5434 13.7315 14.5613 13.7136 14.5852 13.7017C14.5911 13.7017 14.5911 13.6957 14.5971 13.6957C14.621 13.6778 14.6449 13.6599 14.6688 13.642C15.3972 13.0628 15.8271 12.1791 15.7256 11.4208C15.6838 11.3491 15.6301 11.2835 15.5704 11.2357L14.3284 10.3162C14.209 10.2266 14.0359 10.3102 14.0359 10.4595V12.6269C14.0359 13.9883 12.979 14.4003 12.979 14.4003C12.979 14.4003 13.7791 14.1316 14.0359 14.0181C14.0836 13.9942 14.1314 13.9704 14.1792 13.9465Z",
    fill: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9541 15.9494L18.1858 13.1367C18.1798 13.1367 18.1798 13.1307 18.1738 13.1307L16.7764 12.0916C16.657 12.002 16.4897 12.0856 16.4897 12.2349V19.9805C16.5017 20.1179 16.5196 20.2612 16.5495 20.3985C16.5793 20.5299 16.6211 20.6553 16.6808 20.7628C16.5793 20.0044 17.0093 19.1205 17.7379 18.5413C17.8991 18.4099 18.1201 18.2666 18.3649 18.165C18.6217 18.0516 19.422 17.7828 19.422 17.7828L21.8167 16.9169C22.2288 16.7616 22.3064 16.2122 21.9541 15.9494Z",
    fill: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2228 18.2311C18.2169 18.2371 18.2049 18.2371 18.1989 18.2431C18.187 18.249 18.1751 18.255 18.1572 18.267C18.1392 18.2729 18.1273 18.2849 18.1094 18.2908C18.1034 18.2968 18.0915 18.3028 18.0855 18.3028C18.0676 18.3147 18.0437 18.3267 18.0258 18.3386C18.0198 18.3446 18.0139 18.3446 18.0079 18.3505C17.99 18.3625 17.9721 18.3744 17.9482 18.3864C17.9362 18.3923 17.9303 18.3983 17.9183 18.4043C17.9064 18.4162 17.8885 18.4222 17.8765 18.4341C17.8586 18.4461 17.8407 18.464 17.8168 18.4759C17.8108 18.4759 17.8108 18.4819 17.8049 18.4819C17.781 18.4998 17.7571 18.5177 17.7332 18.5356C17.0048 19.1148 16.5749 19.9985 16.6764 20.7568C16.7182 20.8285 16.7719 20.8941 16.8316 20.9419L18.0676 21.8614C18.187 21.951 18.3602 21.8674 18.3602 21.7181V19.5507C18.3602 18.1953 19.417 17.7773 19.417 17.7773C19.417 17.7773 18.6169 18.046 18.3602 18.1595C18.3184 18.1834 18.2706 18.2072 18.2228 18.2311Z",
    fill: "#F7F7FC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridgeIconActive);
export default __webpack_public_path__ + "static/media/bridgeIconActive.0eb6b4788d6a13384575e0224180222d.svg";
export { ForwardRef as ReactComponent };